import h from 'virtual-dom/h';

export default function FooterResizeIcon(settings) {
    const getReducer  = () => (state => state);
    const getRenderer = () => () => h('div', { className: settings.classNames.resizeIcon }, []);
    return { getReducer, getRenderer };
}


// WEBPACK FOOTER //
// ./components/renderers/footer-resize-icon/footer-resize-icon.js